import { useTranslation } from 'react-i18next'
import { Link, Outlet, useLocation } from 'react-router'

import { PageHeader } from 'app/common/presentation'
import { UserIcon, WorkspaceIcon } from 'app/common/presentation/icons'
import { useUser } from 'app/user/application'

import { SideMenuItem } from '../component'
import styles from './Settings.module.scss'

const Settings = () => {
  const { t } = useTranslation('settings')
  const location = useLocation()
  const { user } = useUser()

  const settings = [
    {
      key: 'workspace',
      adminOnly: false,
      icon: WorkspaceIcon,
      path: '/settings/workspace',
    },
    {
      key: 'user',
      adminOnly: false,
      icon: UserIcon,
      path: '/settings/user',
    },
    {
      key: 'users',
      adminOnly: true,
      icon: WorkspaceIcon,
      path: '/settings/users',
    },
    {
      key: 'access',
      adminOnly: false,
      icon: WorkspaceIcon,
      path: '/settings/access',
    },
  ]

  return (
    <div className={styles.settings}>
      <PageHeader title={t('title')} />
      <div className={styles.content}>
        <ul className={styles.sidebar}>
          {settings
            .filter((setting) => !setting.adminOnly || user?.isAdmin)
            .map((menuItem) => (
              <li key={menuItem.key}>
                <Link to={menuItem.path}>
                  <SideMenuItem
                    active={location.pathname === menuItem.path}
                    icon={menuItem.icon}
                    title={t(`menu.${menuItem.key}`)}
                  />
                </Link>
              </li>
            ))}
        </ul>
        <div className={styles.mainContent}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Settings
